import DiscountGoodsExamine from './discount_examine.vue';

export default DiscountGoodsExamine;
